import React from 'react'

import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import withWidth from '@material-ui/core/withWidth';

//import ScreenCamView from './recorderViews/ScreenCamView';
import ScreenView from './recorderViews/ScreenView';
import CameraView from './recorderViews/CameraView';
import IViewQueryParams from '../../recorderView/ui/IViewQueryParams';
import ErrorPage from '../../common/ui/ErrorPage';

interface Props {
  width: string;
  queryParams: IViewQueryParams;
  handleChangeSourceSelected: (index: number) => void,
  handleChangeAudioAllowed: (value: boolean) => void,
  handleChangeVideoAllowed: (value: boolean) => void,  
  sourceSelected: number,
  isAudioAllowed: boolean,
  isVideoAllowed: boolean
}

interface State {
}

declare global {
  interface Window {
      MediaRecorder: any;
  }
}

class Recorder extends React.Component<Props> {

  renderErrorPage = () => {
    return (
      <ErrorPage />      
    );
  }  

  render() {
    if (window.MediaRecorder === undefined) {
      return this.renderErrorPage();
    } else {
      return (  
        <Container maxWidth="sm">      
          <Box>     
            <Box px={this.props.width === 'sm' ? 0 : 4} my={2} textAlign="center">
              {/* 
                <ScreenCamView
                    queryParams={this.props.queryParams}
                    sourceSelected={this.props.sourceSelected}
                    isAudioAllowed={this.props.isAudioAllowed}
                    isVideoAllowed={this.props.isVideoAllowed}
                    handleChangeSourceSelected={this.props.handleChangeSourceSelected}
                    handleChangeAudioAllowed={this.props.handleChangeAudioAllowed}
                    handleChangeVideoAllowed={this.props.handleChangeVideoAllowed}
                /> 
              */}
              <ScreenView
                queryParams={this.props.queryParams}
                sourceSelected={this.props.sourceSelected}
                isAudioAllowed={this.props.isAudioAllowed}
                isVideoAllowed={this.props.isVideoAllowed}
                handleChangeSourceSelected={this.props.handleChangeSourceSelected}
                handleChangeAudioAllowed={this.props.handleChangeAudioAllowed}
                handleChangeVideoAllowed={this.props.handleChangeVideoAllowed}
              />
              <CameraView
                queryParams={this.props.queryParams}
                sourceSelected={this.props.sourceSelected}
                isAudioAllowed={this.props.isAudioAllowed}
                isVideoAllowed={this.props.isVideoAllowed}
                handleChangeSourceSelected={this.props.handleChangeSourceSelected}
                handleChangeAudioAllowed={this.props.handleChangeAudioAllowed}
                handleChangeVideoAllowed={this.props.handleChangeVideoAllowed}
              />
            </Box>
          </Box>
        </Container>
      );
    }     
  }

  }

export default withWidth()(Recorder);